import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      let rotation = 0;
      $( '.left-right-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--left-right-slider' )[0], {
          type: 'fade',
          pagination: false,
          arrows: true,
          gap: '0',
          perPage: 1,
          autoWidth: false,
          drag: false,
          flickMaxPages: 0,
          speed: 0,
          rewindSpeed: 0,
          waitForTransition: false,
        } );


        splide.on( 'moved', function( newIndex, oldIndex ) {
          if ( newIndex > oldIndex ) {
            rotation -= 2;
          } else {
            rotation += 2;
          }

          $( component ).find( '.splide__track' ).css( 'transform', `rotate(${rotation}deg)` );
          console.log( `rotate(${rotation}deg)` );

          splide.Components.Slides.forEach( function( slide ) {
            slide.slide.classList.toggle( 'is-past', slide.index < newIndex );
          } );
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'left-right-slider', COMPONENT );
} )( app );
